import { getOrigin, getCalendarPath } from 'owa-url';
import type { ProjectId } from 'owa-timestream-types';
import { useProjectId } from './useProjectId';
import getProjectName from '../util/getProjectName';

export default function useProjectHref(): [string, string, ProjectId] {
    const projectId = useProjectId();
    const projectUrl = getOrigin() + getCalendarPath() + 'view/board/id/' + projectId;
    return [getProjectName(projectId), projectUrl, projectId];
}
